module.exports = __webpack_public_path__ + "static/media/cost-approval.c993f45a.svg";